export default function ForbiddenPage() {
  return (
    <div>
      <h1>403: Acceso prohibido</h1>
      <p>No tienes permisos para acceder a esta página. Si crees que esto es un error, contacta al administrador.</p>
    </div>
  )
}
